module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user"
    }
  }, [_c('div', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": this.user.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(this.user.loginname))]), _vm._v(" "), _c('div', {
    staticClass: "user-bottom"
  }, [_c('span', [_vm._v("注册:")]), _vm._v(" "), _c('span', {
    staticClass: "user-time"
  }, [_vm._v(_vm._s(_vm._f("getLastTime")(this.user.create_at)))]), _vm._v(" "), _c('span', [_vm._v("积分:")]), _vm._v(" "), _c('span', {
    staticClass: "user-score"
  }, [_vm._v(_vm._s(this.user.score))])])]), _vm._v(" "), _c('div', {
    staticClass: "user-topic-reply"
  }, [_c('ul', {
    staticClass: "user-tabs"
  }, [_c('li', {
    staticClass: "item",
    class: {
      selected: _vm.isTopic
    },
    on: {
      "click": _vm.checkTopic
    }
  }, [_vm._v("最新发布")]), _vm._v(" "), _c('li', {
    staticClass: "item",
    class: {
      selected: !_vm.isTopic
    },
    on: {
      "click": _vm.checkTopic
    }
  }, [_vm._v("最近回复")])])]), _vm._v(" "), _c('div', {
    staticClass: "topic-list"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTopic),
      expression: "isTopic"
    }],
    staticClass: "posts-list"
  }, _vm._l((this.user.recent_topics), function(item) {
    return _c('li', [_c('div', {
      staticClass: "summary "
    }, [_c('div', {
      staticClass: "details"
    }, [_c('div', [_c('h2', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getDetail(item.id)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.title) + "\n                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm._f("getLastTime")(item.last_reply_at)) + "\n                      ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-user-circle-o"
    }), _vm._v(" " + _vm._s(item.author.loginname) + "\n                      ")])])])])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTopic),
      expression: "!isTopic"
    }],
    staticClass: "reply-list"
  }, [_c('ul', {
    staticClass: "posts-list"
  }, _vm._l((this.user.recent_replies), function(item) {
    return _c('li', [_c('div', {
      staticClass: "summary "
    }, [_c('div', {
      staticClass: "details"
    }, [_c('div', [_c('h2', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getDetail(item.id)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item.title) + "\n                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm._f("getLastTime")(item.last_reply_at)) + "\n                      ")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-user-circle-o"
    }), _vm._v(" " + _vm._s(item.author.loginname) + "\n                      ")])])])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-77ffb3c8"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/user.vue
// module id = 157
// module chunks = 1